import React from 'react';

const Mange = () => {
    return (
        <div>
            <h1>this is manage inventory page </h1>
        </div>
    );
};

export default Mange;